"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight01Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { ComponentProps, FC } from "react";
import { cn } from "../../utils";
import { Button } from "../button";
import useSlider from "./hooks/useSlider";
import {
  arrowOffset,
  sliderArrowIconVariants,
  sliderArrowVariants,
} from "./variants";

type Props = ComponentProps<typeof Button> & {
  placement?: "outside" | "edge";
  iconClassName?: string;
};

const SliderNext: FC<Props> = ({
  className,
  iconClassName,
  children,
  placement = "outside",
  variant = "outline",
  size = "icon-sm",
  ...props
}) => {
  const { scrollNext, canScrollNext, dir } = useSlider();

  return (
    <Button
      data-slot="slider-next"
      variant={variant}
      size={size}
      className={cn(
        sliderArrowVariants({ placement }),
        arrowOffset(placement, "next", dir),
        className,
      )}
      disabled={!canScrollNext}
      onClick={scrollNext}
      {...props}
    >
      {children ?? (
        <HugeiconsIcon
          icon={ArrowRight01Icon}
          className={cn(sliderArrowIconVariants({ placement }), iconClassName)}
        />
      )}
      <span className="sr-only">Next slide</span>
    </Button>
  );
};

export default SliderNext;
